import { render, staticRenderFns } from "./myClasses.vue?vue&type=template&id=e4584bac&scoped=true"
import script from "./myClasses.vue?vue&type=script&lang=js"
export * from "./myClasses.vue?vue&type=script&lang=js"
import style0 from "./myClasses.vue?vue&type=style&index=0&id=e4584bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4584bac",
  null
  
)

export default component.exports